import React from "react";
import { useTranslation } from "react-i18next";
import heroBg from "../../images/Home_Public_339ea30a2c.jpg";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section
      style={{
        position: "relative",
        backgroundImage: `url(${heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        minHeight: "400px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "80px 10%",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(90deg, rgba(0,76,63,0.85) 0%, rgba(200,16,46,0.70) 100%)",
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <div style={{ position: "relative", zIndex: 2, maxWidth: "600px" }}>
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "600",
            letterSpacing: "1px",
            fontSize: "14px",
            marginBottom: "15px",
          }}
        >
          {t("HeroSection.CTA2", { defaultValue: "Join the Initiative" })}
        </p>

        <h1
          style={{
            fontSize: "36px",
            lineHeight: "1.3",
            marginBottom: "20px",
            fontWeight: "700",
          }}
        >
          {t("HeroSection.Title", { defaultValue: "Emirates Made – Proudly Made in the Emirates" })}
        </h1>

        <p
          style={{
            fontSize: "16px",
            marginBottom: "30px",
            color: "#d5e6e3",
          }}
        >
          {t("HeroSection.Description", { defaultValue: "Official UAE initiative celebrating locally made products, innovation and national industry excellence." })}
        </p>

        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <a
            href="/manufacturers"
            style={buttonStyle}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#d5e6e3")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            {t("HeroSection.CTA1", { defaultValue: "Explore Members" })}
          </a>
          <a
            href="/register"
            style={buttonStyle}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#d5e6e3")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            {t("HeroSection.CTA2", { defaultValue: "Join the Initiative" })}
          </a>
          <a
            href="/label"
            style={buttonStyle}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#d5e6e3")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            {t("HeroSection.CTA3", { defaultValue: "Discover the Label" })}
          </a>
        </div>
      </div>
    </section>
  );
};

const buttonStyle = {
  display: "inline-block",
  backgroundColor: "#fff",
  color: "#00352d",
  fontWeight: "600",
  textDecoration: "none",
  padding: "12px 28px",
  borderRadius: "25px",
  transition: "0.3s",
};

export default HeroSection;


// import React from "react";
// import { useTranslation } from "react-i18next";
// import heroBg from "../../images/Home_Public_339ea30a2c.jpg";

// const HeroSection = () => {
//   const { t } = useTranslation();

//   return (
//     <section
//       style={{
//         position: "relative",
//         backgroundImage: `url(${heroBg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         color: "#fff",
//         minHeight: "400px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "flex-start",
//         padding: "80px 10%",
//       }}
//     >
//       {/* Dark overlay */}
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           backgroundColor: "rgba(0, 45, 39, 0.85)",
//           zIndex: 1,
//         }}
//       ></div>

//       {/* Content */}
//       <div style={{ position: "relative", zIndex: 2, maxWidth: "600px" }}>
//         <p
//           style={{
//             textTransform: "uppercase",
//             fontWeight: "600",
//             letterSpacing: "1px",
//             fontSize: "14px",
//             marginBottom: "15px",
//           }}
//         >
//           {t("HeroSection.JoinCommunity")}
//         </p>
//         <h1
//           style={{
//             fontSize: "36px",
//             lineHeight: "1.3",
//             marginBottom: "20px",
//             fontWeight: "700",
//           }}
//         >
//           {t("HeroSection.Title")}
//         </h1>
//         <p
//           style={{
//             fontSize: "16px",
//             marginBottom: "30px",
//             color: "#d5e6e3",
//           }}
//         >
//           {t("HeroSection.Description")}
//         </p>
//         <a
//           href="#eligibility"
//           style={{
//             display: "inline-block",
//             backgroundColor: "#fff",
//             color: "#00352d",
//             fontWeight: "600",
//             textDecoration: "none",
//             padding: "12px 28px",
//             borderRadius: "25px",
//             transition: "0.3s",
//           }}
//           onMouseEnter={(e) => (e.target.style.backgroundColor = "#d5e6e3")}
//           onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
//         >
//           {t("HeroSection.CheckEligibility")}
//         </a>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;
